import configuration from 'globalConfiguration';
import eventHelper from 'helper/eventHelper';
import 'plugins/jquery.actual';
import htmlComposer from 'helper/htmlComposer';
import scrollHelper from 'helper/scrollHelper';
import 'helper/jquery.fracs';

function addClassDelay(element, className, delay) {
	var $addClassDelayElement = $(element),
		$addClassName = className;
	$addClassDelayElement.addClass($addClassName);
	setTimeout(function () {
		$addClassDelayElement.removeClass($addClassName);
	}, delay);
}

function SectionScrollHelper() {
	this.configuration = configuration.SectionScrollHelper;
	this.sections = [];
	this.arrows = {
		arrowTop: undefined,
		arrowDown: undefined,
	};
	/**
	 * @type {JQuery<HTMLDivElement>}
	 */
	this.wofContainer = undefined;
	this.document = $(document);
	this.init();

	this.doAutoScroll = true;
}

SectionScrollHelper.prototype = {

	init: function () {
		this.addEventListener();
	},

	reset: function () {
		this.sections = [];
		this.resetScrollArrows();
		if (this.wofContainer) {
			this.wofContainer.remove();
			this.wofContainer.empty();
			this.wofContainer = null;
		}
		this.removePluginEventListeners();
		this.removeEventListener();
	},

	resetScrollArrows: function () {
		if (this.arrows.arrowDown) {
			this.arrows.arrowDown.remove();
			this.arrows.arrowDown = undefined;
		}
		if (this.arrows.arrowTop) {
			this.arrows.arrowTop.remove();
			this.arrows.arrowTop = undefined;
		}
	},

	addEventListener: function () {
		this.document.on('ajaxPageLoadStart', $.proxy(this.reset, this));
		this.document.on('ajaxPageLoaded', $.proxy(this.collectSections, this));
		$(window)
			.on('scroll', $.proxy(this.scrollSmartWoFContainer, this));
	},

	removeEventListener: function () {
		$(window)
			.off('scroll', $.proxy(this.scrollSmartWoFContainer, this));
	},

	addPluginEventListeners: function () {
		$(window)
			.on('resize.wofContainer', $.proxy(this.calculatePositionOfWoFContainer, this));
		this.document.on('PanelTrigger_toggle', $.proxy(this.checkAllSectionsInWoFContainer, this));
		this.document.on('PanelTrigger_toggle', $.proxy(this.calculatePositionOfWoFContainer, this));
		this.document.on('toggleHelper_toggleAllButtonCreated', $.proxy(this.calculatePositionOfWoFContainer, this));

		if (this.document.find(this.configuration.contentSelector + ' ' + '.panel').length > 0) {
			eventHelper.deferredEmit($.proxy(this.checkAllSectionsInWoFContainer, this), 'allPanelsReady', this.document);
		}
	},

	removePluginEventListeners: function () {
		$(window)
			.off('scroll.wofHeadline');
		$(window)
			.off('resize.wofContainer');
		this.document.off('PanelTrigger_toggle');
		this.document.off('toggleHelper_toggleAllButtonCreated');
	},

	collectSections: function () {
		this.sections = this.document.find(this.configuration.contentSelector + ' ' + this.configuration.sectionSelector);
		this.setSectionsData();
		if (this.sections.length >= this.configuration.minSectionCount) {
			this.createWheelOfFortuneContainer();
			this.appendSectionsIntoWoFContainer();
			this.calculatePositionOfWoFContainer();
			this.checkAllSectionsInWoFContainer();
			this.addPluginEventListeners();

			this.wofContainer.hide();
			this.document.find('body')
				.append(this.wofContainer);
			this.scaleSmartWoFContainer();
			this.wofContainer.show();
			this.scaleSmartWoFContainer();

			this.wofContainer.on('mouseenter', $.proxy(this.onMouseEnterOnWoFContainer, this));
			this.wofContainer.on('mouseleave', $.proxy(this.onMouseLeaveOnWoFContainer, this));
		}
	},

	getScrollPositionForWoFContainer: function (event) {
		let wrapperMousePositionY = event.pageY - $(event.currentTarget)
			.offset().top;
		let percentageOfElement = wrapperMousePositionY / $(event.currentTarget)
			.height();
		let scrollTop = this.wofContainer[0].scrollHeight * (percentageOfElement - 0.5);

		this.checkArrowAndWoFContainerStateAfterScrolling(scrollTop);

		return this.wofContainer[0].scrollHeight * (percentageOfElement - 0.5);
	},

	checkArrowAndWoFContainerStateAfterScrolling: function (scrollTop) {
		this.wofContainer.removeClass('maxTop maxBottom');
		if (this.arrows.arrowDown && this.arrows.arrowTop) {
			this.arrows.arrowDown.removeClass('max');
			this.arrows.arrowTop.removeClass('max');
			if (this.wofContainer[0].scrollHeight - this.wofContainer.height() - scrollTop <= 0) {
				this.arrows.arrowDown.addClass('max');
				this.wofContainer.addClass('maxBottom');
			}
			if (scrollTop <= 0) {
				this.arrows.arrowTop.addClass('max');
				this.wofContainer.addClass('maxTop');
			}
		}
	},

	onMouseEnterOnWoFContainer: function (event) {
		this.wofContainer.addClass('open');
		this.doAutoScroll = false;
		this.wofContainer.stop()
			.animate({
				scrollTop: this.getScrollPositionForWoFContainer(event),
			}, 800, function () {
				if (this.wofContainer) {
					this.wofContainer.on('mousemove', $.proxy(this.onMouseMoveOnWoFContainer, this));
					this.doAutoScroll = true;
				}

			}.bind(this));
	},

	onMouseLeaveOnWoFContainer: function () {
		this.wofContainer.removeClass('open');
		this.wofContainer.off('mousemove', $.proxy(this.onMouseMoveOnWoFContainer, this));
	},

	onMouseMoveOnWoFContainer: function (event) {
		this.wofContainer.scrollTop(this.getScrollPositionForWoFContainer(event));
	},

	setSectionsData: function () {
		let validSections = [];
		$.each(this.sections, function (index, section) {
			let currentSection = $(section);
			$.each(this.configuration.possibleSections, function (selectorClass, sectionConfig) {
				if (currentSection.hasClass(selectorClass)) {
					currentSection.data('headline', currentSection.find(sectionConfig.header));
					currentSection.data('content', currentSection.find(sectionConfig.content));
					validSections.push(currentSection);
					return false;
				} else if (currentSection.hasClass('groupSeparator')) {
					currentSection.data('headline', currentSection);
					currentSection.data('content', currentSection);
					validSections.push(currentSection);
					return false;
				}
			}.bind(this));
		}.bind(this));
		this.sections = validSections;
	},

	scaleSmartWoFContainer: function () {
		let viewport = {
			height: window.innerHeight,
			width: window.innerWidth,
		};
		let scaleFactorMin = 0.8;
		let scaleFactorMax = 0.9;
		let height = this.wofContainer[0].scrollHeight != 0
			? this.wofContainer[0].scrollHeight
			: this.wofContainer.actual('outerHeight');

		if (height > viewport.height * scaleFactorMax) {
			this.wofContainer.height(viewport.height * scaleFactorMin);
			this.wofContainer.addClass('isScaled');
			this.createScrollArrows();
		} else {
			this.wofContainer.height(height);
			this.wofContainer.removeClass('isScaled');
			this.resetScrollArrows();
		}
	},

	createScrollArrows: function () {
		if (typeof this.arrows.arrowTop === 'undefined' && typeof this.arrows.arrowDown === 'undefined') {
			this.arrows.arrowTop = htmlComposer.generateDiv('wofArrowTop wofArrow');
			this.arrows.arrowDown = htmlComposer.generateDiv('wofArrowDown wofArrow');
			this.wofContainer.after(this.arrows.arrowTop)
				.after(this.arrows.arrowDown);
			this.correctPositionOfScrollArrows();
		}
	},

	correctPositionOfScrollArrows: function () {
		if (this.arrows.arrowTop) {
			this.arrows.arrowTop.css({
				top: this.wofContainer.offset().top - window.pageYOffset - this.arrows.arrowTop.outerHeight() - 10,
				left: this.wofContainer.offset().left - window.pageXOffset + this.wofContainer.outerWidth() - this.arrows.arrowTop.outerWidth() + this.configuration.arrowOffset.x,
			});
		}
		if (this.arrows.arrowDown) {
			this.arrows.arrowDown.css({
				top: this.wofContainer.offset().top - window.pageYOffset + this.wofContainer.outerHeight() + 10,
				left: this.wofContainer.offset().left - window.pageXOffset + this.wofContainer.outerWidth() - this.arrows.arrowDown.outerWidth() + this.configuration.arrowOffset.x,
			});
		}
	},

	createWheelOfFortuneContainer: function () {
		this.wofContainer = htmlComposer.generateDiv('wofWrapper', 'wofWrapper');
	},

	appendSectionsIntoWoFContainer: function () {
		$.each(this.sections, function (index, section) {
			$(section)
				.data('originalPosition', $(section)
					.offset().top)
				.data('originalHeight', $(section)
					.outerHeight());
			this.wofContainer.append(this.createSectionLink(section));
		}.bind(this));
		if (this.wofContainer.find('.inviewport').length > 0) {
			this.wofContainer.children()
				.each(function (index, sectionGroup) {
					this.checkVisibilityOfSectionGroup($(sectionGroup));
				}.bind(this));
		}
	},

	createSectionLink: function (sectionParam) {
		let section = $(sectionParam);
		let sectionGroup = htmlComposer.generateDiv('wofSectionGroup');
		let wofElement = htmlComposer.generateDiv('wofElement');

		// fracs
		section.fracs($.proxy(this.doUpdateSection, this, sectionGroup));
		wofElement.text(section.data('headline')
			.text());

		if (section.data('content')
			.find('.error.small').length > 0) {
			sectionGroup.addClass('containsErrors');
		}
		if (section.hasClass('groupSeparator')) {
			sectionGroup.addClass('wofSeparator');
		} else {
			sectionGroup.on('click', $.proxy(this.onWoFElementClick, this, section));
			sectionGroup.on('mouseenter', $.proxy(this.onWoFElementEnter, this, section));
			sectionGroup.on('mouseleave', $.proxy(this.onWoFElementLeave, this, section));
		}
		sectionGroup.append(wofElement);

		return sectionGroup;
	},

	checkAllSectionsInWoFContainer: function () {
		$.each(this.sections, function (index, section) {
			section.fracs('check');
		}.bind(this));
	},

	calculatePositionOfWoFContainer: function () {
		let content = $(this.configuration.contentSelector);

		this.correctHorizontalPositionOfWofContainer(content);
		this.scaleSmartWoFContainer();
		// buggy
		// this.correctVerticalPositionOfWofContainer(content);
		this.correctPositionOfScrollArrows();
	},

	correctVerticalPositionOfWofContainer: function (content) {
		if (content.offset().top + content.height() <= window.innerHeight) {
			// content < window
			let verticalPosition = content.height() / 2 + content.offset().top;
			this.wofContainer.css('top', verticalPosition);
		} else {
			// content > window
			if (this.wofContainer.position().top <= content.offset().top) {
				this.wofContainer.css('top', content.offset().top + this.wofContainer.height() / 2);
			} else {
				this.wofContainer.css('top', '50%');
			}
		}
	},

	correctHorizontalPositionOfWofContainer: function (content) {
		if ('right' == this.configuration.position) {
			this.wofContainer.css('right', window.innerWidth - content.offset().left - content.actual('outerWidth') - 50 + this.configuration.wofContainerOffset.x);
		} else {
			this.wofContainer.css('left', content.offset().left + this.configuration.wofContainerOffset.x);
		}
	},

	onWoFElementClick: function (section) {
		let windowHeight = $(window)
			.height();
		let sectionHeight = section.actual('outerHeight');
		let pluginPanelData = section.data('plugin_Panel');

		let dfd = jQuery.Deferred();
		let scrollPromise = dfd.promise();

		if (sectionHeight >= windowHeight) {
			this.doAutoScroll = false;
			$.when(scrollPromise)
				.then(function () {
					this.doAutoScroll = true;
				}.bind(this));
			scrollHelper.scrollToElement(section, 500, dfd);
		} else {
			this.doAutoScroll = false;
			let scrollpoint = section.offset().top - windowHeight / 2 + sectionHeight / 2 - 10;
			$.when(scrollPromise)
				.then(function () {
					this.doAutoScroll = true;
				}.bind(this));
			scrollHelper.scrollToPosition(scrollpoint, 500, dfd);
		}
		if (this.containsNoError(section)) {
			if (section.hasClass('groupSeparator')) {
				addClassDelay(section.parent(), 'highlightFlash', 800);
			} else {
				addClassDelay(section, 'highlightFlash', 800);
			}
		}
		if (typeof pluginPanelData != 'undefined' && pluginPanelData.getState() != 'opened') {
			pluginPanelData.onClick('sectionScrollHelper');
		}
	},

	onWoFElementEnter: function (section) {
		if (this.containsNoError(section)) {
			if (section.hasClass('groupSeparator')) {
				section.parent()
					.addClass('highlightFlash');
			} else {
				section.addClass('highlightFlash');
			}
		}
	},

	onWoFElementLeave: function (section) {
		if (this.containsNoError(section)) {
			if (section.hasClass('groupSeparator')) {
				section.parent()
					.removeClass('highlightFlash');
			} else {
				section.removeClass('highlightFlash');
			}
		}
	},

	doUpdateSection: function (sectionGroup, fracs) {
		if (1 - fracs.visible < 1) {
			sectionGroup.addClass('inviewport');
			//this.checkVisibilityOfSectionGroup(sectionGroup);
		} else {
			sectionGroup.removeClass('inviewport');
		}
	},

	containsNoError: function (section) {
		if (!section.hasClass('containsErrors') || section.parent()
			.hasClass('containsErrors')) {
			return true;
		}
		return false;
	},

	checkVisibilityOfSectionGroup: function (sectionGroup) {
		if (this.doAutoScroll && !this.wofContainer.hasClass('open')) {
			let sectionGroupTop = sectionGroup.offset().top;
			let wrapperOffsetTop = this.wofContainer.offset().top;
			let wrapperHeight = this.wofContainer.outerHeight();
			let toScroll = false;

			if (sectionGroupTop >= wrapperOffsetTop + wrapperHeight) {
				let lastSectionGroupInWoFContainerInViewport = sectionGroup.parent()
					.find('.inviewport')
					.last();
				toScroll = lastSectionGroupInWoFContainerInViewport.offset().top - wrapperOffsetTop - wrapperHeight + lastSectionGroupInWoFContainerInViewport.outerHeight() + this.wofContainer.scrollTop();
			} else if (sectionGroupTop < wrapperOffsetTop) {
				let firstSectionGroupInWoFContainerInViewport = sectionGroup.parent()
					.find('.inviewport')
					.first();
				toScroll = firstSectionGroupInWoFContainerInViewport.offset().top - wrapperOffsetTop + this.wofContainer.scrollTop();
			}

			if (toScroll !== false) {
				this.wofContainer.stop()
					.animate({
						scrollTop: toScroll,
					}, 200, function () {
						this.checkArrowAndWoFContainerStateAfterScrolling(toScroll);
					}.bind(this));
			}
		}
	},
};

export default new SectionScrollHelper();
